import styled from 'styled-components'
import { desktopBreakpoint } from 'react-components'

export const StyledNavigationItem = styled.a`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: ${({ theme }) => theme.style.display.flex};
        margin-right: ${({ theme }) => theme.layout.medium};
        font-family: ${({ theme }) => theme.typography.font.family.lato};
        font-size: ${({ theme }) => theme.typography.font.size.medium};
        font-weight: 300;
        line-height: normal;
        text-decoration: none;
        color: ${({ theme }) => theme.colors.tfwBlack87};

        &:hover {
            text-decoration: underline;
        }
    }
`
